
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('jarallax', {
        async mounted(el, binding = {
            value: {}
        }, vnode, prevVnode) {
            const { ssrContext } = useNuxtApp();
            if (!ssrContext && navigator && navigator.userAgent) {
                const { jarallax } = await import('jarallax');
                jarallax(el, binding.value)
            }
            // const swiper = new Swiper(el,binding.value)

        },
        created(el, binding, vnode, prevVnode) {
            // 下面会介绍各个参数的细节
            // console.log("createedSwiper", binding)
        },
        getSSRProps(binding, vnode) {
            // you can provide SSR-specific props here
            return {}
        }
    })
    // nuxtApp.vueApp.directive('jarallaxVideo', {
    //     mounted(el, binding, vnode, prevVnode) {
    //         console.log("A");
    //         // const swiper = new Swiper(el,binding.value)

    //     },
    //     created(el, binding, vnode, prevVnode) {
    //         // 下面会介绍各个参数的细节
    //         console.log("createedSwiper", binding)
    //     },
    //     getSSRProps(binding, vnode) {
    //         // you can provide SSR-specific props here
    //         return {}
    //     }
    // })
})